import { Stack, Typography, styled } from "@mui/material"
import { EvolutionStatChip, isDefined } from "@pharmupp/p3-front-commons"

export const LoyaltyProgramEvolution = ({
  title,
  subtitle,
  evolution,
}: {
  title: string
  subtitle: string
  evolution: number | null | undefined
}) => {
  return (
    <Stack gap={1}>
      <Stack>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Stack>
      {/* GROWTH */}
      {isDefined(evolution) ? <EvolutionChip bold evol={evolution} /> : "-"}
    </Stack>
  )
}

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey.light,
  fontWeight: 600,
  textTransform: "uppercase",
}))
Title.defaultProps = {
  variant: "body2",
}

const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey.light,
}))
Subtitle.defaultProps = {
  variant: "caption",
}

const EvolutionChip = styled(EvolutionStatChip)({})
EvolutionChip.defaultProps = {
  arrow: true,
  border: false,
  formatOptions: { maximumFractionDigits: 1 },
}
